import { render, staticRenderFns } from "./Software.vue?vue&type=template&id=175246dd&scoped=true"
import script from "./Software.vue?vue&type=script&lang=js"
export * from "./Software.vue?vue&type=script&lang=js"
import style0 from "./Software.vue?vue&type=style&index=0&id=175246dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175246dd",
  null
  
)

export default component.exports